module.exports = __webpack_public_path__ + "static/img/rightms.6b5b2e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/rightms.png
// module id = aSY/
// module chunks = 1